(function () {
  'use strict';

  // ===================================================================
  // GCLID CAPTURE — Google Click ID fuer Offline Conversion Import (OCI)
  // Liest ?gclid= aus der URL, speichert in localStorage + Cookie (90 Tage)
  // Injiziert in Helium Customer Fields Registrierungsformular
  // ===================================================================

  var GCLID_KEY = 'gclid';
  var CAMPAIGN_KEY = 'utm_campaign';
  var GCLID_EXPIRY_DAYS = 90; // Google Attribution Window

  function captureGclid() {
    var params = new URLSearchParams(window.location.search);
    var gclid = params.get('gclid');
    var campaign = params.get('utm_campaign');

    if (gclid) {
      // Neuer Ad-Click: gclid + campaign speichern
      localStorage.setItem(GCLID_KEY, gclid);
      localStorage.setItem(GCLID_KEY + '_ts', Date.now().toString());
      setCookie(GCLID_KEY, gclid, GCLID_EXPIRY_DAYS);
    }
    if (campaign) {
      localStorage.setItem(CAMPAIGN_KEY, campaign);
      setCookie(CAMPAIGN_KEY, campaign, GCLID_EXPIRY_DAYS);
    }
  }

  function getStoredGclid() {
    var gclid = localStorage.getItem(GCLID_KEY);
    if (!gclid) return getCookie(GCLID_KEY);

    // Pruefen ob aelter als 90 Tage
    var ts = parseInt(localStorage.getItem(GCLID_KEY + '_ts') || '0', 10);
    if (ts && (Date.now() - ts) > GCLID_EXPIRY_DAYS * 24 * 60 * 60 * 1000) {
      localStorage.removeItem(GCLID_KEY);
      localStorage.removeItem(GCLID_KEY + '_ts');
      return null;
    }
    return gclid;
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value)
      + ';expires=' + expires + ';path=/;SameSite=Lax';
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function getStoredCampaign() {
    return localStorage.getItem(CAMPAIGN_KEY) || getCookie(CAMPAIGN_KEY) || null;
  }

  function injectGclidIntoForms() {
    var gclid = getStoredGclid();
    var campaign = getStoredCampaign();
    if (!gclid && !campaign) return;

    // Helium Customer Fields: hidden input in Registrierungsformularen
    // Selektoren fuer Helium + Standard-Shopify Account-Formulare
    var formSelectors = [
      'form[action*="/account"]',           // Shopify Account Create
      'form[data-customer-form]',           // Helium Customer Fields
      'form.helium-form',                   // Helium alternate
      '#create_customer',                   // Shopify default register form
      'form[action*="customer"]'            // Fallback
    ];

    formSelectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (form) {
        // gclid Hidden Field
        if (gclid && !form.querySelector('input[name="customer[note][gclid]"]')) {
          var hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'customer[note][gclid]';
          hidden.value = gclid;
          form.appendChild(hidden);
        }
        // utm_campaign Hidden Field
        if (campaign && !form.querySelector('input[name="customer[note][utm_campaign]"]')) {
          var campaignField = document.createElement('input');
          campaignField.type = 'hidden';
          campaignField.name = 'customer[note][utm_campaign]';
          campaignField.value = campaign;
          form.appendChild(campaignField);
        }
      });
    });

    // Helium Custom Field: Falls ein gclid-Feld existiert (in Helium Admin angelegt)
    var heliumField = document.querySelector(
      'input[name*="gclid"], input[data-field-name="gclid"]'
    );
    if (heliumField && !heliumField.value && gclid) {
      heliumField.value = gclid;
    }
  }

  // Ausfuehren: gclid aus URL lesen
  captureGclid();

  // Forms befuellen sobald DOM bereit
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectGclidIntoForms);
  } else {
    injectGclidIntoForms();
  }

  // MutationObserver: Falls Helium das Formular spaeter rendert (SPA/AJAX)
  var observer = new MutationObserver(function () {
    injectGclidIntoForms();
  });
  observer.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true
  });

  // Global verfuegbar fuer andere Scripts/Webhooks
  window.__gclid = getStoredGclid();
  window.__utm_campaign = getStoredCampaign();

  // ===================================================================
  // GCLID SYNC — ENTFERNT 2026-04-28 (n8n-Phaseout)
  // Frueher: Document-Click/Submit-Listener + window.fetch-Override
  // Jetzt: Receiver
  // nimmt den Shopify customer-create Webhook entgegen und schreibt direkt
  // in Supabase.
  // ===================================================================

  // ===================================================================
  // QUICK ADD + ACCESSORIES — Bestehende Shopify Funktionalitaet
  // ===================================================================

  function pinQuickAddToBottom() {
  // CSS flex + margin-top: auto uebernimmt Alignment
  // Alte inline styles aufraeumen falls noch vorhanden
  document.querySelectorAll('.card-quick-add').forEach(function (el) {
    var p = el.parentElement;
    if (p) {
      p.style.position = '';
      p.style.paddingBottom = '';
    }
    el.style.position = '';
    el.style.bottom = '';
    el.style.left = '';
  });
}


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pinQuickAddToBottom);
  } else {
    pinQuickAddToBottom();
  }

  var SEL_BLOCK    = '.card-quick-add';
  var SEL_INPUT    = '.card-quick-add__qty-input';
  var SEL_MINUS    = '.card-quick-add__qty-btn--minus';
  var SEL_PLUS     = '.card-quick-add__qty-btn--plus';
  var SEL_VARIANT  = '.card-quick-add__variant-select';
  var SEL_BTN      = '.card-quick-add__cart-btn';
  var SEL_FEEDBACK = '.card-quick-add__feedback';

  function getBlock(el) { return el.closest(SEL_BLOCK); }
  function clamp(v, mn, mx) { return Math.min(Math.max(v, mn), mx); }

  function setButtonState(btn, state) {
    btn.setAttribute('data-state', state);
    var labels = {
      idle:   'In den Warenkorb',
      adding: 'Wird hinzugef\u00fcgt\u2026',
      added:  'Hinzugef\u00fcgt',
      error:  'Fehler'
    };
    btn.setAttribute('aria-label', labels[state] || labels.idle);
  }

  function showFeedback(block, msg, type) {
    var el = block.querySelector(SEL_FEEDBACK);
    if (!el) return;
    if (type === 'success') {
      el.innerHTML = msg + ' &mdash; <a href="/cart">Warenkorb &rarr;</a>';
    } else {
      el.textContent = msg;
    }
    el.className = 'card-quick-add__feedback card-quick-add__feedback--' + type;
  }

  function clearFeedback(block) {
    var el = block.querySelector(SEL_FEEDBACK);
    if (!el) return;
    el.innerHTML = '';
    el.className = 'card-quick-add__feedback';
  }

  function getVariantId(block) {
    var select = block.querySelector(SEL_VARIANT);
    if (select && select.value) return select.value;
    return block.dataset.variantId;
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: quantity }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Unbekannter Fehler'); });
      return r.json();
    });
  }

  // FIX: /cart.js statt FoxTheme.routes.cart_url
  // FoxTheme.routes.cart_url gibt im Theme Editor checkouts/sim/... zurueck → 403 Forbidden
  // /cart.js ist der native Shopify AJAX Endpunkt — kein Redirect, funktioniert ueberall
  function notifyCartUpdate(addedItems) {
    var sectionParam = window.FoxKitSections;

    var cartFetch = fetch('/cart.js')
      .then(function (r) { return r.json(); });

    var sectionFetch = sectionParam
      ? fetch('/?sections=' + sectionParam).then(function (r) { return r.json(); })
      : Promise.resolve({});

    Promise.all([cartFetch, sectionFetch])
      .then(function (res) {
        var cartJson = res[0];
        cartJson.sections = res[1];

        FoxTheme.pubsub.publish(
          FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
          { cart: cartJson }
        );

        document.dispatchEvent(new CustomEvent('product-ajax:added', {
          detail: { product: addedItems || cartJson },
          bubbles: true
        }));

        document.querySelectorAll('[data-cart-count], .cart-count-bubble, .header__cart-count, .cart-icon-bubble').forEach(function (el) {
          el.textContent = cartJson.item_count;
          if (cartJson.item_count > 0) el.removeAttribute('hidden');
        });
      })
      .catch(function (err) { console.error('[CartUpdate Error]', err); });
  }

  document.addEventListener('click', function (e) {

    // Accessories Stepper +/- (vor Quick-Add Handlern — kein Selektor-Konflikt)
    var accMinus = e.target.closest('.acc-item__qty-btn--minus');
    if (accMinus) {
      var accItem = accMinus.closest('.acc-item');
      var i = accItem && accItem.querySelector('.acc-item__qty-input');
      if (i) i.value = clamp(parseInt(i.value, 10) - 1, 1, 999);
      return;
    }
    var accPlus = e.target.closest('.acc-item__qty-btn--plus');
    if (accPlus) {
      var accItem = accPlus.closest('.acc-item');
      var i = accItem && accItem.querySelector('.acc-item__qty-input');
      if (i) i.value = clamp(parseInt(i.value, 10) + 1, 1, 999);
      return;
    }

    // Quick Add Stepper +/-
    var minus = e.target.closest(SEL_MINUS);
    if (minus) {
      var b = getBlock(minus), i = b && b.querySelector(SEL_INPUT);
      if (i) i.value = clamp(parseInt(i.value, 10) - 1, 1, 999);
      return;
    }
    var plus = e.target.closest(SEL_PLUS);
    if (plus) {
      var b = getBlock(plus), i = b && b.querySelector(SEL_INPUT);
      if (i) i.value = clamp(parseInt(i.value, 10) + 1, 1, 999);
      return;
    }

    // Accessories Cart Button
    var accBtn = e.target.closest('.acc-btn[data-add]');
    if (accBtn) {
      var accItem = accBtn.closest('.acc-item');
      if (!accItem || accBtn.disabled || accBtn.dataset.state === 'adding') return;
      var variantId = accItem.dataset.variantId;
      if (!variantId) return;
      var accQtyInput = accItem.querySelector('.acc-item__qty-input');
      var accQty = accQtyInput ? (parseInt(accQtyInput.value, 10) || 1) : 1;
      accBtn.dataset.state = 'adding';
      accBtn.disabled = true;
      addToCart(variantId, accQty)
        .then(function (added) {
          accBtn.dataset.state = 'added';
          accBtn.disabled = false;
          notifyCartUpdate(added);
          setTimeout(function () { accBtn.dataset.state = ''; }, 2500);
        })
        .catch(function () {
          accBtn.dataset.state = 'error';
          accBtn.disabled = false;
          setTimeout(function () { accBtn.dataset.state = ''; }, 3000);
        });
      return;
    }

    // Quick Add Cart Button
    var btn = e.target.closest(SEL_BTN);
    if (!btn) return;
    var block = getBlock(btn);
    if (!block || btn.getAttribute('data-state') === 'adding') return;
    var variantId = getVariantId(block);
    var input = block.querySelector(SEL_INPUT);
    var qty = parseInt(input ? input.value : '1', 10) || 1;
    if (!variantId) { showFeedback(block, 'Variante nicht gefunden', 'error'); return; }
    setButtonState(btn, 'adding');
    clearFeedback(block);
    addToCart(variantId, qty)
      .then(function (addedItems) {
        setButtonState(btn, 'added');
        showFeedback(block, qty + '\u00d7 hinzugef\u00fcgt', 'success');
        notifyCartUpdate(addedItems);
        setTimeout(function () { setButtonState(btn, 'idle'); clearFeedback(block); }, 3000);
      })
      .catch(function (err) {
        setButtonState(btn, 'error');
        showFeedback(block, err.message || 'Fehler beim Hinzuf\u00fcgen', 'error');
        setTimeout(function () { setButtonState(btn, 'idle'); clearFeedback(block); }, 3500);
      });
  });

  document.addEventListener('blur', function (e) {
    var input = e.target.closest(SEL_INPUT) || e.target.closest('.acc-item__qty-input');
    if (!input) return;
    var v = parseInt(input.value, 10);
    if (isNaN(v) || v < 1) input.value = 1;
    else if (v > 999) input.value = 999;
  }, true);

  document.addEventListener('change', function (e) {
    var select = e.target.closest(SEL_VARIANT);
    if (!select) return;
    var block = getBlock(select);
    if (block) block.dataset.variantId = select.value;
  });

})();
